import React, { Component } from "react";
import RenderFormField from "./RenderFormField";
import { Row, Col } from "react-bootstrap";
import "./form-field.style.scss";

const partyTypeOptions = [
  { label: "Enterprise", value: "enterprise" },
  { label: "Individual", value: "individual" },
  { label: "Financial Institution", value: "financial_institution" },
];

const customerInformationFields = [
  {
    name: "customer_id",
    type: "input",
    label: "CIF (Customer ID)",
  },
  {
    name: "customer_name",
    type: "input",
    label: "Customer Name",
  },
  {
    name: "tax_code",
    type: "input",
    label: "Tax Code",
  },
  {
    name: "party_type",
    type: "dropdown",
    label: "Party Type",
    options: partyTypeOptions,
  },
  {
    name: "financial_statement_date",
    type: "datePicker",
    label: "Latest Report Date",
  },
  {
    name: "total_assets",
    type: "input-number",
    label: "Total Asset",
  },
  {
    name: "revenue",
    type: "input-number",
    label: "Revenue",
  },
  {
    name: "historical_rating_latest_rating",
    type: "input",
    label: "Rating",
  },
];

export default class CustomerInfoCorNew extends Component {
  render() {
    const RenderCom = this.props.isView
      ? require("./RenderFormFieldView").default
      : RenderFormField;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <p className="FormTitle">Customer Information (New to Bank)</p>
          </Col>
        </Row>
        <Row>
          {customerInformationFields.map((field) => (
            <Col key={field.name} xs={12} md={6}>
              <RenderCom {...field} formValues={this.props.formValues} />
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/CustomerInfoCorNew.js